import React from 'react';

function formatNumber(value) {
  return new Intl.NumberFormat('de-DE').format(Number(value || 0));
}

export function EventLeaderboard({ rows = [], compact = false }) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return <div className="pfp-event-empty">Noch keine Punkte in dieser Challenge.</div>;
  }

  return (
    <div className={`pfp-event-leaderboard ${compact ? 'pfp-event-leaderboard--compact' : ''}`}>
      {rows.map((row) => (
        <div className="pfp-event-leaderboard-row" key={`${row.rank}-${row.user_id}`}>
          <span className="pfp-event-rank">{row.rank}</span>
          <span className="pfp-event-name">{row.username || 'Pirat'}</span>
          <strong>{formatNumber(row.points)} P</strong>
          {!compact ? (
            <small>
              {formatNumber(row.reports_count)} Meldungen - {formatNumber(row.collected_count)} Abholungen
            </small>
          ) : null}
        </div>
      ))}
    </div>
  );
}

export default EventLeaderboard;
